module.exports = __webpack_public_path__ + "img/pr-1.1e1c4136.png";